// Mock data for 3D Printer Gear Service & Repair landing page

const FAQ_ID_SAME_DAY_SERVICE = 11;
const FAQ_ID_COMMON_REPAIR_PROBLEMS = 13;

export const companyInfo = {
  name: "3D Printer Gear",
  tagline: "Australia's Trusted 3D Printer Repair Partner",
  experience: "12+ Years",
  schoolsServed: "600+",
  printersRepaired: "1,500+",
  logo: "https://customer-assets.emergentagent.com/job_print-rescue/artifacts/a51v4wxf_Logo.svg",
  repairCentreImage: "https://customer-assets.emergentagent.com/job_print-rescue/artifacts/nfiqym4e_Untitled%20design%20%285%29.png",
  technicianImage: "https://customer-assets.emergentagent.com/job_print-rescue/artifacts/nvt6tyqq_WhatsApp%20Image%202025-08-26%20at%208.10.18%20PM.jpeg",
  additionalImages: {
    printerEquipment: "https://images.unsplash.com/photo-1739607448062-7d4accb12fe1",
    repairWork: "https://images.unsplash.com/photo-1735875530804-d661ca2001da", 
    advancedSetup: "https://images.unsplash.com/photo-1539261840634-2966927034c1"
  }
};

export const contactInfo = {
  address: "781 High Street, Reservoir, Victoria 3073",
  phone: "1300 334 327",
  phoneOption: "Option 2 for repairs",
  email: "admin@3dprintergear.com.au",
  businessHours: {
    weekdays: "Mon - Fri: 9am - 6pm",
    saturday: "Saturday: 10am - 4pm",
    sunday: "Sunday: Appointment Only"
  },
  abn: "ABN: 76 662 174 745",
  copyright: "© 2026"
};

export const conversionImages = {
  heroRepairTechnician: "https://customer-assets.emergentagent.com/job_cb81446b-1202-4c9a-b0c7-95681ab8e7c8/artifacts/otzur5re_ChatGPT%20Image%20May%2011%2C%202026%2C%2011_00_44%20AM.png",
  schoolFleetService: "https://static.prod-images.emergentagent.com/jobs/cb81446b-1202-4c9a-b0c7-95681ab8e7c8/images/dd99565750f7fe1dec6ff807e6071402feb4283c88b27d0ab493622b01e70b89.png"
};

export const services = [
  {
    id: 1,
    title: "In-Store Repair",
    description: "Send, drop off, or arrange support for expert diagnosis and repair through our Australia-wide service network.",
    features: ["Expert diagnosis", "Genuine parts", "Same-day options", "Warranty included"],
    icon: "Wrench"
  },
  {
    id: 2,
    title: "On-Site Service", 
    description: "Our certified technicians come to your location for repairs and maintenance.",
    features: ["Certified technicians", "On-site repairs", "Minimal downtime", "Australia-wide coverage"],
    icon: "Truck"
  },
  {
    id: 3,
    title: "Preventative Maintenance",
    description: "Keep your printers running smoothly with scheduled maintenance programs.",
    features: ["Regular servicing", "Performance optimization", "Extended lifespan", "Priority support"],
    icon: "Calendar"
  }
];

// Comprehensive list of supported brands and their popular models
export const supportedBrandsDetailed = [
  {
    brand: "Bambu Lab",
    logo: "/brand-logos/bambulab.png",
    models: ["X1 Carbon", "X1E", "P1P", "P1S", "P2S", "A1", "A1 Mini", "H2S", "H2D", "H2D Pro", "H2C"]
  },
  {
    brand: "Prusa",
    logo: "/brand-logos/prusa.svg",
    models: ["MK4S", "MK4", "MK3S+", "MINI+", "XL", "CORE One", "CORE One L", "SL1S Speed", "i3 MK3", "MMU3"]
  },
  {
    brand: "Creality",
    logo: "/brand-logos/creality.svg",
    models: ["Ender 3 V3", "Ender 3 V3 SE", "Ender 3 S1", "Ender 3 S1 Pro", "Ender 5 Plus", "CR-10", "CR-6 SE", "K1", "K1C", "K1 Max", "K1 SE", "K2 Plus", "K2 Pro", "Sermoon D1", "Halot Mage"]
  },
  {
    brand: "Anycubic",
    logo: "/brand-logos/anycubic.svg",
    models: ["Kobra 3", "Kobra 2", "Kobra Plus", "Kobra Max", "Vyper", "Mega X", "Mega S", "Photon Mono (Resin)", "Photon M7 (Resin)"]
  },
  {
    brand: "Qidi Tech",
    logo: "/brand-logos/qiditech.svg",
    models: ["X-Plus 3", "X-Max 3", "X-CF Pro", "Q1 Pro", "i-Fast", "Smart Pro"]
  },
  {
    brand: "Elegoo",
    logo: "/brand-logos/elegoo.svg",
    models: ["Neptune 4 Pro", "Neptune 4", "Neptune 3", "Neptune 2", "Mars 5 (Resin)", "Saturn 4 (Resin)", "Jupiter (Resin)"]
  },
  {
    brand: "Ultimaker",
    logo: "/brand-logos/ultimaker.png",
    models: ["S7", "S5", "S3", "Method X", "Method XL", "Factor 4"]
  },
  {
    brand: "MakerBot",
    logo: "/brand-logos/makerbot.svg",
    models: ["Replicator+", "Method X", "Method", "Sketch", "Z18"]
  },
  {
    brand: "Snapmaker",
    logo: "/brand-logos/snapmaker.svg",
    models: ["Artisan", "A350T", "A250T", "J1", "J1s", "2.0"]
  },
  {
    brand: "FlashForge",
    logo: "/brand-logos/flashforge.svg",
    models: ["Adventurer 5M", "Adventurer 5M Pro", "Adventurer 4", "Creator Pro 2", "Guider 2S", "Dreamer"]
  },
  {
    brand: "Raise3D",
    logo: "/brand-logos/raise3d.svg",
    models: ["Pro3 Plus", "Pro3", "Pro2", "E2", "E2CF", "RMF500"]
  },
  {
    brand: "Artillery",
    logo: "https://www.3dprintergear.com.au/assets/webshop/cms/29/529.png",
    models: ["Sidewinder X4 Plus", "Sidewinder X2", "Genius Pro", "Hornet"]
  },
  {
    brand: "LulzBot",
    logo: "/brand-logos/lulzbot.png",
    models: ["TAZ Pro S", "TAZ Pro", "TAZ Workhorse", "Mini 2", "Sidekick"]
  },
  {
    brand: "Tiertime",
    logo: "/brand-logos/tiertime.svg",
    models: ["UP600", "UP300", "UP Mini 2", "Cetus3D"]
  },
  {
    brand: "Zortrax",
    logo: "/brand-logos/zortrax.svg",
    models: ["M300 Plus", "M200 Plus", "Inkspire 2", "Endureal"]
  },
  {
    brand: "Formlabs",
    logo: "/brand-logos/formlabs.png",
    models: ["Form 4", "Form 3+", "Form 3L", "Form 3BL", "Form 2 (Resin)", "Fuse 1+ 30W (SLS)"]
  },
  {
    brand: "Markforged",
    logo: "/brand-logos/markforged.svg",
    models: ["FX20", "X7", "Mark Two", "Onyx Pro", "Onyx One"]
  },
  {
    brand: "Voron",
    logo: "/brand-logos/voron.png",
    models: ["2.4", "0.2", "Trident", "Switchwire", "Legacy"]
  },
  {
    brand: "Sovol",
    logo: "/brand-logos/sovol.png",
    models: ["SV08", "SV07 Plus", "SV07", "SV06 Plus", "SV06", "SV01 Pro"]
  },
  {
    brand: "Monoprice",
    logo: "/brand-logos/monoprice.svg",
    models: ["Voxel", "Select Mini V2", "MP Cadet", "Ultimate 2"]
  },
  {
    brand: "Dremel",
    logo: "/brand-logos/dremel_real.svg",
    models: ["DigiLab 3D45", "3D40 Flex", "3D20"]
  },
  {
    brand: "XYZprinting",
    logo: "/brand-logos/xyzprinting.svg",
    models: ["da Vinci Color", "da Vinci Pro", "Nobel 1.0A", "PartPro"]
  },
  {
    brand: "Tronxy",
    logo: "/brand-logos/tronxy.png",
    models: ["X5SA Pro", "X5SA", "XY-2 Pro", "X5SA-500"]
  },
  {
    brand: "Anet",
    logo: "/brand-logos/anet.svg",
    models: ["A8 Plus", "A8", "ET4", "ET5", "E16"]
  },
  {
    brand: "Geeetech",
    logo: "/brand-logos/geeetech.png",
    models: ["Mizar S", "A10M", "A20M", "Thunder", "E180"]
  },
  {
    brand: "Airwolf 3D",
    logo: "/brand-logos/airwolf.svg",
    models: ["EVO 22", "AXIOM 20", "AXIOM Dual", "HD2x"]
  },
  {
    brand: "BCN3D",
    logo: "/brand-logos/bcn3d.png",
    models: ["Omega I60", "Epsilon W50", "Epsilon W27", "Sigma D25"]
  },
  {
    brand: "Leapfrog",
    logo: "/brand-logos/leapfrog.svg",
    models: ["ONE", "Creatr HS", "Creatr", "Xeed", "Bolt Pro"]
  },
  {
    brand: "Modix",
    logo: "/brand-logos/modix.jpg",
    models: ["BIG-40", "BIG-60 V4", "BIG-120X", "BIG-120Z", "BIG-Meter"]
  },
  {
    brand: "Wanhao",
    logo: "/brand-logos/wanhao.png",
    logoDarkBg: true,
    models: ["Duplicator i3 Plus", "Duplicator 9", "Duplicator 12", "D12 Idex", "GR1"]
  }
];

// Google Reviews data matching 3dprintergear.com.au
export const googleReviewsData = {
  rating: 4.9,
  totalReviews: "700+",
  googleMapsUrl: "https://www.google.com/maps/place/3D+Printer+Gear/@-37.7289268,145.0053949,17z/data=!4m6!3m5!1s0x6ab8a55f52fe73bd:0xd4c76c0dcf1ce596!8m2!3d-37.7289268!4d145.0053949!16s%2Fg%2F11j6tzsgn0?entry=ttu",
  reviews: [
    {
      id: 1,
      name: "David W.",
      initial: "D",
      content: "Fast delivery, great prices, and excellent support when I had questions about setup. Will definitely shop here again!",
      rating: 5
    },
    {
      id: 2,
      name: "James R.",
      initial: "J",
      content: "These guys really know their stuff. Got expert advice and my printer was set up and running the same day. 10/10!",
      rating: 5
    },
    {
      id: 3,
      name: "Rachel P.",
      initial: "R",
      content: "Ordered a Bambu Lab printer and it arrived perfectly packaged. Setup was a breeze thanks to their detailed instructions.",
      rating: 5
    }
  ]
};

// Facility images
export const facilities = {
  serviceCentre: {
    title: "Service & Repair Centre",
    image: "https://customer-assets.emergentagent.com/job_repair-booking-5/artifacts/lph7zvxz_image.png",
    description: "Our fully equipped service centre houses a fleet of 3D printers and all the specialised tools needed for expert diagnosis and repair. Drop-off, send-in, remote triage and scheduled on-site support are available Australia-wide depending on the repair need.",
    features: ["Fully stocked spare parts inventory", "Specialised diagnostic equipment", "Same-day repair capability", "All major brands serviced"]
  },
  trainingCentre: {
    title: "Training Centre",
    image: "https://customer-assets.emergentagent.com/job_repair-booking-5/artifacts/wwmyf3dq_image.png",
    description: "Our dedicated training space is set up with multiple 3D printers for hands-on learning. Whether you're a beginner or looking to advance your skills, our bootcamps and workshops cover everything from basic operation to advanced slicing techniques.",
    features: ["Hands-on workshops with real printers", "Beginner to advanced courses", "Small class sizes for personalised learning", "Taught by experienced technicians"]
  }
};

// Common 3D printer issues - what happens when you don't service your printer
export const commonPrinterIssues = [
  {
    id: 1,
    title: "The Blob of Death",
    shortDesc: "Molten filament engulfs your entire hotend",
    image: "https://customer-assets.emergentagent.com/job_492b09b9-1422-4ecb-b153-90af34f221f5/artifacts/98vgspfx_Blob%20Of%20Death.jpeg",
    badge: "Catastrophic Failure",
    description: "The dreaded 'blob of death' happens when filament escapes from the nozzle and wraps around your entire hotend assembly. The massive ball of molten plastic engulfs the heater block, thermistor, wiring, and fan duct — often causing permanent damage that requires full hotend replacement.",
    bulletPoints: [
      "Clogged nozzles force filament to leak from the heatbreak joint",
      "Degraded PTFE tubes lose their seal allowing filament to escape",
      "Failed thermistor readings cause uncontrolled heating and oozing",
      "Regular nozzle cleaning and hotend inspections prevent catastrophic blobs"
    ],
    causes: "Nozzle clogs, loose heatbreak, PTFE tube degradation, failed thermistor readings",
    prevention: "Regular nozzle cleaning and hotend inspections prevent catastrophic blob failures"
  },
  {
    id: 2,
    title: "Bed Adhesion Failure",
    shortDesc: "Prints detach, warp, and turn into spaghetti",
    image: "https://customer-assets.emergentagent.com/job_492b09b9-1422-4ecb-b153-90af34f221f5/artifacts/5ll807jz_bed%20adhesion.webp",
    badge: "Most Common Failure",
    description: "When your print bed isn't properly calibrated or maintained, prints lose grip mid-way through. Hours of print time are wasted as objects warp, curl at the edges, or completely detach — turning into a tangled mess of spaghetti filament all over your build plate.",
    bulletPoints: [
      "Worn or contaminated build surfaces lose their grip over time",
      "Unlevelled beds create uneven first layers that peel away",
      "Failing heated bed elements cause inconsistent temperatures",
      "Regular bed calibration prevents 90% of adhesion failures"
    ],
    causes: "Worn build plates, unlevelled beds, contaminated surfaces, failing heated bed elements",
    prevention: "Regular bed calibration and surface maintenance prevents 90% of adhesion failures"
  },
  {
    id: 3,
    title: "Layer Shifting",
    shortDesc: "Layers misalign creating a staircase effect",
    image: "https://customer-assets.emergentagent.com/job_492b09b9-1422-4ecb-b153-90af34f221f5/artifacts/yd42bdm0_layer%20shifting.jpg",
    badge: "Mechanical Failure",
    description: "Layer shifting occurs when the print head or bed loses its position during a print. The result is a visible offset in layers, creating a 'staircase' pattern that completely ruins the structural integrity and appearance of your print. This often worsens over time as belts stretch and bearings wear.",
    bulletPoints: [
      "Loose belts and worn pulleys cause the print head to skip steps",
      "Bent lead screws create progressive shifting that worsens per layer",
      "Stepper motor issues and failing drivers produce random offsets",
      "Belt tension checks and mechanical inspections catch these early"
    ],
    causes: "Loose belts, worn pulleys, stepper motor issues, bent lead screws, failing bearings",
    prevention: "Belt tension checks and mechanical inspections catch these issues before they destroy prints"
  },
  {
    id: 4,
    title: "Stringing & Under-Extrusion",
    shortDesc: "Weak prints with gaps, wisps, and missing layers",
    image: "https://images.pexels.com/photos/31336922/pexels-photo-31336922.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    badge: "Progressive Failure",
    description: "Stringing leaves thin wisps of filament between print features, while under-extrusion creates weak prints with gaps, holes, and missing layers. Both issues progressively worsen as your nozzle wears, PTFE degrades, and extruder gears lose their grip — eventually making your printer unusable.",
    bulletPoints: [
      "Partially clogged nozzles restrict flow causing gaps and weak layers",
      "Worn extruder gears slip on filament reducing extrusion consistency",
      "Degraded PTFE tubes create friction that starves the hotend of material",
      "Regular extruder maintenance and nozzle swaps keep prints clean and strong"
    ],
    causes: "Partial nozzle clogs, worn extruder gears, PTFE degradation, incorrect retraction settings",
    prevention: "Regular extruder maintenance and nozzle swaps keep prints clean and strong"
  }
];

// Simple brand list for quick reference
export const supportedBrands = supportedBrandsDetailed.map(item => item.brand);

export const whyChooseUs = [
  {
    icon: "Award",
    title: "12+ Years Experience", 
    description: "Industry-leading expertise across every type of FDM 3D printer"
  },
  {
    icon: "Building",
    title: "Fully Equipped Centre",
    description: "State-of-the-art repair facility with Australia-wide support, specialist tools and stocked parts"
  },
  {
    icon: "Users",
    title: "National Service Team",
    description: "Certified technicians available for on-site service across Australia"
  },
  {
    icon: "Clock",
    title: "Same-Day Repairs",
    description: "Urgent repair options available for time-sensitive projects"
  },
  {
    icon: "Shield",
    title: "Trusted by Education",
    description: "All staff have Working with Children Checks and police clearances"
  },
  {
    icon: "Banknote",
    title: "Flexible Payment",
    description: "30-day payment terms for schools with purchase orders"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael R.",
    content: "Excellent service and knowledgeable staff. They fixed my Prusa MK3S+ quickly and professionally. The team really knows their stuff when it comes to 3D printers. Highly recommended!",
    rating: 5,
    timeAgo: "2 weeks ago"
  },
  {
    id: 2,
    name: "Amanda K.", 
    content: "Great experience with 3D Printer Gear. They provided expert advice on my printer issues and got everything sorted efficiently. Their technical knowledge is impressive.",
    rating: 5,
    timeAgo: "1 month ago"
  },
  {
    id: 3,
    name: "David W.",
    content: "Outstanding customer service! The staff went above and beyond to help diagnose and repair my Creality printer. Fast turnaround and fair pricing. Will definitely use them again.",
    rating: 5,
    timeAgo: "3 weeks ago"
  },
  {
    id: 4,
    name: "Jennifer M.",
    content: "Professional and reliable service. They've been servicing our school's 3D printer fleet for over a year now. Always prompt, knowledgeable, and helpful with any issues we have.",
    rating: 5,
    timeAgo: "2 months ago"
  },
  {
    id: 5,
    name: "Robert L.",
    content: "Fantastic repair work on my Bambu Lab printer. The technician was very experienced and explained everything clearly. Got my printer running better than ever!",
    rating: 5,
    timeAgo: "1 week ago"
  },
  {
    id: 6,
    name: "Sarah T.",
    content: "Exceptional service from start to finish. They diagnosed the problem quickly, provided a clear quote, and completed the repair on time. Very satisfied with their work.",
    rating: 5,
    timeAgo: "3 weeks ago"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Contact Us",
    description: "Call, email, or fill out our online form to describe your printer issue"
  },
  {
    step: 2, 
    title: "Get Quote",
    description: "Receive a transparent quote with no hidden fees or surprises"
  },
  {
    step: 3,
    title: "Book Service", 
    description: "Schedule in-store drop-off or on-site service at your convenience"
  },
  {
    step: 4,
    title: "Expert Repair",
    description: "Our certified technicians diagnose and repair using genuine parts"
  },
  {
    step: 5,
    title: "Quality Check",
    description: "Thorough testing ensures your printer is working perfectly"
  }
];

export const featureSections = [
  {
    id: 1,
    title: "Easily get expert repairs for any printer brand",
    description: "3D Printer Gear makes it easy to get professional repair services for your FDM 3D printers Australia-wide. You can drop off, send in, book on-site service, or arrange preventative maintenance. Everything is handled by certified technicians with genuine parts. No more printer downtime disrupting your workflow.",
    features: [
      "Same-day repair options for urgent jobs",
      "Certified technicians with 12+ years experience", 
      "All major FDM printer brands supported",
      "Fully equipped repair centre"
    ],
    image: companyInfo.additionalImages.printerEquipment,
    imagePosition: "right"
  },
  {
    id: 2, 
    title: "Work your way (minus the hassle)",
    description: "3D Printer Gear works with schools, businesses and hobbyists across Australia. We integrate seamlessly with your existing workflow and provide flexible payment terms. All our technicians have Working with Children Checks for educational environments. You can work the way you're used to without the hassle of unreliable printers.",
    features: [
      "30-day payment terms for schools with PO",
      "Working with Children Checks for all staff",
      "National on-site service coverage",
      "Professional indemnity and public liability insurance"
    ],
    image: companyInfo.repairCentreImage,
    imagePosition: "left"
  }
];

export const stats = [
  { number: "12+", label: "Years Experience" },
  { number: "600+", label: "Schools Served" },
  { number: "20k", label: "Australian Customers" },
  { number: "1,500+", label: "Printers Serviced" }
];

export const faqs = [
  {
    id: 1,
    category: "Service Types",
    question: "What's the difference between In-Store and On-Site service?",
    answer: "In-Store service means your printer is handled through our fully equipped repair centre for comprehensive diagnosis and repair. On-Site service means certified technicians attend your location where available and practical. On-site is ideal for large printers, multiple machines, schools, businesses, or when you can't transport the printer."
  },
  {
    id: 2,
    category: "Service Types", 
    question: "What is Preventative Maintenance?",
    answer: "Preventative Maintenance is a scheduled service program designed to keep your 3D printers running smoothly and prevent breakdowns before they occur. This includes regular cleaning, lubrication, belt tension checks, nozzle cleaning, bed leveling, firmware updates, and replacement of wear parts like nozzles and PTFE tubes. We recommend preventative maintenance every 3-6 months depending on usage, especially for schools and businesses with multiple printers."
  },
  {
    id: 3,
    category: "Service Types",
    question: "Can you service multiple printers for a school or business?",
    answer: "Yes. Schools, makerspaces and businesses can book multiple machines in one request. Include each printer brand, model and symptom in the booking form so our team can plan the visit, quote accurately and bring the right parts or tools where possible."
  },
  {
    id: 4,
    category: "Pricing & Payment",
    question: "How much does repair service cost?",
    answer: "We provide a clear quote before any work begins. The final quote depends on the printer model, issue type, parts required, repair complexity and whether the job is in-store or on-site. Schools and educational institutions can arrange payment terms with a purchase order."
  },
  {
    id: 5,
    category: "Pricing & Payment",
    question: "Do you offer payment terms for schools?",
    answer: "Yes! We understand the unique needs of educational institutions. Schools and government organizations can arrange 30-day payment terms when providing an official Purchase Order. All our technicians have Working with Children Checks and police clearances, making us fully compliant for educational environments. We also offer bulk pricing for schools with multiple printers requiring service."
  },
  {
    id: 6,
    category: "Repair Process",
    question: "How long does a typical repair take?",
    answer: "Repair time varies depending on the issue and parts availability. Simple repairs like nozzle clogs or bed leveling can often be completed the same day. More complex issues requiring parts may take 3-5 business days. For urgent jobs, we offer priority service with same-day or next-day turnaround when possible. We'll provide an estimated timeframe when we quote the repair."
  },
  {
    id: 7,
    category: "Repair Process",
    question: "What printer brands do you service?",
    answer: "We service all major FDM 3D printer brands including Bambu Lab, Prusa, Creality, Ultimaker, MakerBot, Raise3D, Artillery, FlashForge, Anycubic, LulzBot, and many others. Our technicians have 12+ years of combined experience across virtually every type of FDM printer. If you have a specific brand or model, contact us to confirm compatibility."
  },
  {
    id: 8,
    category: "Parts & Warranty",
    question: "Do you use genuine parts for repairs?",
    answer: "Yes, we stock and use genuine OEM parts whenever possible to ensure the best quality and longevity of repairs. We maintain inventory of common parts for major printer brands. For specialty or discontinued parts, we source high-quality compatible alternatives and will always inform you of the options available. All repairs come with a warranty on our workmanship and the parts we install."
  },
  {
    id: 9,
    category: "Parts & Warranty",
    question: "What warranty do you provide on repairs?",
    answer: "We provide a warranty on our repair workmanship and any parts we install. The specific warranty period depends on the type of repair and parts used, typically ranging from 30-90 days. We'll clearly explain the warranty terms for your specific repair when providing the quote. Our goal is to ensure you're completely satisfied with the repair quality."
  },
  {
    id: 10,
    category: "Booking & Scheduling",
    question: "How do I book a repair service?",
    answer: "You can book a service through our online booking form, call us at 1300 334 327 (option 2), or email admin@3dprintergear.com.au. When booking, please provide details about your printer model, the issue you're experiencing, and your preferred service type (in-store or on-site). We'll contact you within 24 hours to confirm the appointment and provide a quote."
  },
  {
    id: FAQ_ID_SAME_DAY_SERVICE,
    category: "Booking & Scheduling",
    question: "Do you provide same-day service?",
    answer: "Yes, we offer same-day and priority service for urgent repairs when possible, subject to technician availability, location, freight timing and the complexity of the issue. Contact us as early as possible for urgent service requests."
  },
  {
    id: 12,
    category: "Coverage Area",
    question: "What areas do you service for on-site repairs?",
    answer: "We operate Australia-wide. Depending on your location and printer issue, service can be arranged through drop-off, send-in repair, remote triage, or scheduled on-site support. For remote locations, we can arrange extended service visits to handle multiple machines or provide training along with repairs."
  },
  {
    id: FAQ_ID_COMMON_REPAIR_PROBLEMS,
    category: "Common Issues",
    question: "What are the most common 3D printer problems you fix?",
    answer: "The most common issues we repair include: nozzle clogs and jams, bed adhesion problems, layer shifting, under/over-extrusion, heating issues with hotend or bed, mechanical problems with belts and motors, firmware corruption, calibration issues, and filament feeding problems. We also handle more complex issues like mainboard failures, display problems, and complete rebuilds of heavily damaged printers."
  },
  {
    id: 14,
    category: "Preparation",
    question: "How should I prepare my printer for service?",
    answer: "Before bringing your printer for service: remove any filament from the system, clean any loose debris, take photos of error messages or issues, gather any accessories (SD cards, tools, spare parts), and backup any custom settings or profiles if possible. For on-site service, ensure clear access to the printer and have adequate workspace available for our technician."
  }
];